import { ChangeDetectorRef, Component, NgZone, NO_ERRORS_SCHEMA } from '@angular/core';
import { CandidateService } from '../services/candidate.service';
import { Router } from '@angular/router';
import { JobShareService } from '../home/available-jobs/job-share.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-job-landing',
  templateUrl: './job-landing.component.html',
  styleUrl: './job-landing.component.scss',
  imports: [CommonModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class JobLandingComponent {
  [key: string]: any;
  constructor() {}

  ngAfterViewInit() {}
}
